import type { PropsWithChildren, Ref } from 'react';
import { forwardRef } from 'react';

import { TooltipPrimitive } from '@trello/nachos/tooltip';

import styles from './CustomTooltip.less';

export const CustomTooltip = forwardRef(
  (props: PropsWithChildren<unknown>, ref: Ref<HTMLDivElement>) => {
    const { children, ...rest } = props;
    return (
      <TooltipPrimitive
        placement="bottom"
        {...rest}
        ref={ref}
        className={styles.tooltipContainer}
      >
        {children}
      </TooltipPrimitive>
    );
  },
);
